import axios from 'axios';
export const getDetails = () =>{
    return(
          axios.get('https://l5e0chs5b7.execute-api.us-east-1.amazonaws.com/getDetails')
    )
}